import { __module as i } from "./chunk653.js";
import { __require as v } from "./chunk447.js";
var m = i.exports, u;
function q() {
  return u ? i.exports : (u = 1, function(c, U) {
    (function(o, a) {
      c.exports = a(v());
    })(m, function(o) {
      return function() {
        if (typeof ArrayBuffer == "function") {
          var a = o, l = a.lib, e = l.WordArray, t = e.init, b = e.init = function(n) {
            if (n instanceof ArrayBuffer && (n = new Uint8Array(n)), (n instanceof Int8Array || typeof Uint8ClampedArray < "u" && n instanceof Uint8ClampedArray || n instanceof Int16Array || n instanceof Uint16Array || n instanceof Int32Array || n instanceof Uint32Array || n instanceof Float32Array || n instanceof Float64Array) && (n = new Uint8Array(n.buffer, n.byteOffset, n.byteLength)), n instanceof Uint8Array) {
              for (var f = n.byteLength, s = [], r = 0; r < f; r++)
                s[r >>> 2] |= n[r] << 24 - r % 4 * 8;
              t.call(this, s, f);
            } else
              t.apply(this, arguments);
          };
          b.prototype = e;
        }
      }(), o.lib.WordArray;
    });
  }(i), i.exports);
}
export {
  q as __require
};
